import JackpotWindow from './JackpotWindow';
export default JackpotWindow;